export const rolesById = {
  OWNER: {
    id: "owner",
    key: "owner",
    value: "OWNER",
    rank: 5,
  },
  ADMIN: {
    id: "admin",
    key: "admin",
    value: "ADMIN",
    rank: 4,
  },
  STORE: {
    id: "store",
    key: "store",
    value: "STORE",
    rank: 3,
  },
  CUSTOMER_SUPPORT: {
    id: "customerSupport",
    key: "customer_support",
    value: "CUSTOMER_SUPPORT",
    rank: 2,
  },
  LOGISTICIAN: {
    id: "logistician",
    key: "logistician",
    value: "LOGISTICIAN",
    rank: 1,
  },
} as const;
